<div class="hr-slide-area rejected">
  <div class="ol-template-back-bar"></div>
  <div class="ol-template-slide-data">
    <div class="slide-data-area">
      <div class="images-area">
        <img
          class="first-image"
          [src]="initialValue.firstImageUrl"
          alt="logo da empresa"
        />
      </div>
      <div class="ol-template-slide-info">
        <div
          class="ol-template-slide-title"
          [innerHTML]="initialValue.title"
        ></div>
        <div
          class="ol-template-slide-description"
          [innerHTML]="initialValue.description"
        ></div>
        <button class="hr-button-primary btn-download" (click)="downloadPdf()">
          <mat-icon>download</mat-icon>
          Download da carta oferta
        </button>
      </div>
    </div>
  </div>
</div>

<hr-ol-pdf-acceptance style="display: none;" #olPdfAcceptance></hr-ol-pdf-acceptance>
